import React from "react";
import people_img from "../../assets/img/Csr/community.jpg";
import {
  IoCheckmarkCircleOutline,
  IoCloudUploadOutline,
} from "react-icons/io5";
import { LiaHandsHelpingSolid } from "react-icons/lia";
import { LiaUniversitySolid } from "react-icons/lia";

export default function Section6() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={people_img}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              Community Involvement
            </h1>
            <p className="text-lg text-gray-600">
              Aero Aegis Inc. encourages employees to volunteer their time and
              expertise to support local community projects and charities.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <LiaHandsHelpingSolid className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Empowering Employee Volunteerism
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                We motivate our team to actively participate in local community
                projects and charitable initiatives, fostering meaningful
                contributions.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <LiaUniversitySolid className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Sponsorship</h3>
              </div>
              <p className="text-gray-600 text-sm">
                We sponsor educational programs and scholarships to empower
                future generations with knowledge and skills.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
